export enum OutboundShipmentSource {
  Api = "api",
  Checkout = "checkout",
  ConsolidationCarton = "consolidation-carton",
  FulfillmentGroups = "fulfillment-groups",
  OmsReturnLabel = "oms-return-label",
  RateCalculator = "rate-calculator",
}
